import TagManager from "react-gtm-module";
import firebase from "services/firebase";

export function insertTagManagerReligue(code: string): void {
  let event = "";

  switch (code) {
    case "inadimplente":
      event = "religue_solicitacao_inadimplente";
      break;
    case "201":
      event = "religue_solicitacao_solicitado";
      break;
    case "422.007":
      event = "religue_solicitacao_gas_liberado";
      break;
    case "422.008":
      event = "religue_solicitacao_medicao_remota";
      break;
    case "422.009":
      event = "religue_solicitacao_caso_religue_em_aberto";
      break;
    case "422.011":
      event = "religue_solicitacao_unidade_nao_esta";
      break;
    case "422.010":
      event = "religue_solicitacao_unidade_boletos_abertos";
      break;
    case "any":
      event =
        "religue_solicitacao_qualquer_outro_movito_diferente_dos_anteriores";
      break;
    default:
      event =
        "religue_solicitacao_qualquer_outro_movito_diferente_dos_anteriores";
      break;
  }

  firebase.analytics().logEvent(event, {
    customerCode: localStorage.getItem("@UltragazEmpresarial:customerCode"),
    selectedBase: localStorage.getItem("@UltragazEmpresarial:selectedBase"),
    userName: localStorage.getItem("@UltragazEmpresarial:userName"),
  });
  TagManager.initialize({
    gtmId: process.env.REACT_APP_GTM_ID,
    events: {
      event: {
        customerCode: localStorage.getItem("@UltragazEmpresarial:customerCode"),
        selectedBase: localStorage.getItem("@UltragazEmpresarial:selectedBase"),
        userName: localStorage.getItem("@UltragazEmpresarial:userName"),
      },
    },
  });
  TagManager.initialize({
    gtmId: process.env.REACT_APP_GTM_ID,
    dataLayer: {
      event: {
        customerCode: localStorage.getItem("@UltragazEmpresarial:customerCode"),
        selectedBase: localStorage.getItem("@UltragazEmpresarial:selectedBase"),
        userName: localStorage.getItem("@UltragazEmpresarial:userName"),
      },
    },
  });
}

export function logReligueOpenSolicitacao(): void {
  firebase.analytics().logEvent("religue_abrir_solicitacao", {
    customerCode: localStorage.getItem("@UltragazEmpresarial:customerCode"),
    selectedBase: localStorage.getItem("@UltragazEmpresarial:selectedBase"),
    userName: localStorage.getItem("@UltragazEmpresarial:userName"),
  });
  TagManager.initialize({
    gtmId: process.env.REACT_APP_GTM_ID,
    events: {
      religue_abrir_solicitacao: {
        customerCode: localStorage.getItem("@UltragazEmpresarial:customerCode"),
        selectedBase: localStorage.getItem("@UltragazEmpresarial:selectedBase"),
        userName: localStorage.getItem("@UltragazEmpresarial:userName"),
      },
    },
  });
  TagManager.initialize({
    gtmId: process.env.REACT_APP_GTM_ID,
    dataLayer: {
      religue_abrir_solicitacao: {
        customerCode: localStorage.getItem("@UltragazEmpresarial:customerCode"),
        selectedBase: localStorage.getItem("@UltragazEmpresarial:selectedBase"),
        userName: localStorage.getItem("@UltragazEmpresarial:userName"),
      },
    },
  });
}
